<template>
  <div>
    <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
      <template v-slot:item="props">
        <tr>
          <td
            v-for="(header, index) in headers"
            :key="index"
            :class="all(props.index) ? 'red lighten-1' : propRequired(header.value,props.index)"
          >
            <span>{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      default: () => [],
      type: Array
    },
    properties: {
      default: () => [],
      type: Array
    }
  },
  data: () => ({
    headers: [
      {
        text: "EmpCode",
        value: "empCode",
        sortable: false
      },
      {
        text: "Last Name",
        value: "lastName",
        sortable: false
      },
      {
        text: "First Name",
        value: "firstName",
        sortable: false
      },
      {
        text: "Middlename",
        value: "middleName",
        sortable: false
      },
      {
        text: "Suffix",
        value: "suffix",
        sortable: false
      },
      {
        text: "Nick Name",
        value: "nickName",
        sortable: false
      },
      {
        text: "No. and Street",
        value: "noStreet",
        sortable: false
      },
      {
        text: "Barangay or Subdivision",
        value: "barangaySubdivision",
        sortable: false
      },
      {
        text: "City of Municipality",
        value: "city",
        sortable: false
      },
      {
        text: "Province",
        value: "province",
        sortable: false
      },
      {
        text: "Zip Code",
        value: "zipCode",
        sortable: false
      },
      {
        text: "No. and Street",
        value: "noStreet2",
        sortable: false
      },
      {
        text: "Barangay or Subdivision",
        value: "barangaySubdivision2",
        sortable: false
      },
      {
        text: "City of Municipality",
        value: "city2",
        sortable: false
      },
      {
        text: "Province",
        value: "province2",
        sortable: false
      },
      {
        text: "Zip Code",
        value: "zipCode2",
        sortable: false
      },
      {
        text: "No. and Street",
        value: "noStreet3",
        sortable: false
      },
      {
        text: "Barangay or Subdivision",
        value: "barangaySubdivision3",
        sortable: false
      },
      {
        text: "City of Municipality",
        value: "city3",
        sortable: false
      },
      {
        text: "Province",
        value: "province3",
        sortable: false
      },
      {
        text: "Zip Code",
        value: "zipCode3",
        sortable: false
      },
      {
        text: "Citizenship",
        value: "citizenship",
        sortable: false
      },
      {
        text: "Civil Status",
        value: "civilStatus",
        sortable: false
      },
      {
        text: "Gender",
        value: "gender",
        sortable: false
      },
      {
        text: "Weight",
        value: "weight",
        sortable: false
      },
      {
        text: "Height",
        value: "height",
        sortable: false
      },
      {
        text: "Religion",
        value: "religion",
        sortable: false
      },
      {
        text: "Telephone No",
        value: "telNo",
        sortable: false
      },
      {
        text: "Mobile No.",
        value: "mobileNo",
        sortable: false
      },
      {
        text: "Email",
        value: "email",
        sortable: false
      },
      {
        text: "Birth date",
        value: "birthDate",
        sortable: false
      },
      {
        text: "Birth Place",
        value: "birthPlace",
        sortable: false
      },
      {
        text: "Blood Type",
        value: "bloodType",
        sortable: false
      },
      {
        text: "Residence Type",
        value: "residenceType",
        sortable: false
      },
      {
        text: "Contact Person Name",
        value: "contactName",
        sortable: false
      },
      {
        text: "Contact Person Address",
        value: "contactADdress",
        sortable: false
      },
      {
        text: "Relation to Contact Person",
        value: "contactRelation",
        sortable: false
      },
      {
        text: "Contact Person Tel No.",
        value: "contactTelNo",
        sortable: false
      },
      {
        text: "Passport No.",
        value: "passportNo",
        sortable: false
      },
      {
        text: "Passport Issued Date",
        value: "passportIssuedDate",
        sortable: false
      },
      {
        text: "Passport Expiration Date",
        value: "passportExpirationDate",
        sortable: false
      },
      {
        text: "Passport Remarks",
        value: "passportRemarks",
        sortable: false
      },
      {
        text: "Remarks",
        value: "remarks",
        sortable: false
      },
      {
        text: "HRIS",
        value: "hris",
        sortable: false
      },
      {
        text: "Payroll",
        value: "payroll",
        sortable: false
      },
      {
        text: "TKS",
        value: "tks",
        sortable: false
      },
      {
        text: "Endorsed By",
        value: "endorsedBy",
        sortable: false
      },
      {
        text: "SSS No.",
        value: "sssNo",
        sortable: false
      },
      {
        text: "Philhealth No.",
        value: "pHilHealthNo",
        sortable: false
      },
      {
        text: "Pagibig No.",
        value: "pagIbigNo",
        sortable: false
      },
      {
        text: "TIN",
        value: "tin",
        sortable: false
      },
      {
        text: "Online Approval",
        value: "onlineAppCode",
        sortable: false
      }
    ]
  }),
  computed: {},
  methods: {
    propRequired(prop, index) {
      var result = this.properties.filter(item => {
        return (
          item.property.toLowerCase() == prop.toLowerCase() &&
          item.index == index
        );
      });

      if (result.length > 0) return "red lighten-1";
      else return "";
    },
    all(index) {
      var result = this.properties.filter(item => {
        return item.property == "ALL" && item.index == index;
      });
      if (result.length > 0) return true;
      else false;
    }
  }
};
</script>